import React, { useEffect, useState } from "react";
import EmailVerify from "../layouts/Doctor/Components/Dashbord/EmailVerify";
import SecuritySettings from "./Components/HospitalAccountSettings/HospitalSecuritySettings";
import Password from "./Components/HospitalAccountSettings/HospitalPassword";
import EmailNotification from "./Components/HospitalAccountSettings/HospitalEmailNotification";
import SocialAccountDetails from "./Components/HospitalAccountSettings/HospitalSocialAccountDetails";
import DeleteAccount from "./Components/HospitalAccountSettings/HospitalDeleteAccount";
import SeoSettings from "../layouts/Doctor/Components/AccountSettings/SeoSettings";
import { Link, useParams, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getuserdata } from "../services/apiService";
import { oneKlicks } from "../SDK/oneclick";
import { toast } from "react-toastify";
import { debugLog } from "../utils/debug";
import InvoiceSettings from "../layouts/Doctor/Components/AccountSettings/InvoiceSettings";
import BankAccountDetails from "../layouts/Doctor/Components/AccountSettings/BankAccountDetails";

const HospitalAccountSettings = () => {
    const [userdata, setUserdata] = useState({});
    const { sublink } = useParams();
    const [tabsest, setTabseset] = useState("Security & Settings");
    const navigate = useNavigate();
    useEffect(() => {
        const userData = localStorage.getItem("userData");
        debugLog("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    useEffect(() => {
        if (sublink === "Hospital_Security_&_Settings") {
            setTabseset("Security & Settings");
        } else if (sublink === "Hospital_Password") {
            setTabseset("Password");
        } else if (sublink === "Hospital_Email_Notification") {
            setTabseset("Email Notification");
        } else if (sublink === "Hospital_Social_Account_Details") {
            setTabseset("Social Account Details");
        } else if (sublink === "Hospital_Seo_Settings") {
            setTabseset("Seo Settings");
        } else if (sublink === "Hospital_Delete_Account") {
            setTabseset("Delete Account");
        } else if (sublink === "Hospital_Invoice_Settings") {
            setTabseset("Invoice Settings");
        } else if (sublink === "Hospital_Bank_Account_Details") {
            setTabseset("Bank Account Details");
        }
    }, [sublink]);

    const [localInvoice, setLocalInvoice] = useState({
        id: '',
        user_id: '',
        name: '',
        address: '',
        state: '',
        city: '',
        pincode: '',
        country: '',
        phone: '',
        email: '',
        website: '',
        gst_number: ''
    });

    // Tab to URL mapping
    const tabToUrlMapping = {
        "Security & Settings": "Hospital_Security_&_Settings",
        "Password": "Hospital_Password",
        "Email Notification": "Hospital_Email_Notification",
        "Social Account Details": "Hospital_Social_Account_Details",
        "Seo Settings": "Hospital_Seo_Settings",
        "Delete Account": "Hospital_Delete_Account",
        "Invoice Settings": "Hospital_Invoice_Settings",
        "Bank Account Details": "Hospital_Bank_Account_Details"
    };

    const handleTabClick = (tabName) => {
        setTabseset(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/hospital/accountsettings/${urlPath}`);
        }
    };

    const [oldpassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [email, setEmail] = useState("");
    const [oldemail, setOldemail] = useState("");
    const [emailisvalid, setEmailisvalid] = useState(false);


    const [formData, setFormData] = useState({
        password: '',
        retypePassword: '',
        reason: '',
        description: ''
    });

    

    useEffect(() => {
        const fetchEmail = async () => {
            const emailData = await getuserdata("email");
            const emailisvalid = await getuserdata("activation_key");
            debugLog('getuserdata email', emailData);
            debugLog('getuserdata emailisvalid', emailisvalid);
            setEmail(emailData);
            setOldemail(emailData);
            setEmailisvalid(emailisvalid);
        };
        
        fetchEmail();
    }, []);

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        
        // Password validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(newpassword)) {
            toast.error("Password must be at least 8 characters long and contain uppercase, lowercase, number and special character");
            return;
        }

        if (newpassword !== confirmpassword) {
            toast.error("New password and confirm password do not match");
            return;
        }

        try {
            const oldpasswordhash = CryptoJS.SHA256(oldpassword).toString();
            const newpasswordhash = CryptoJS.SHA256(newpassword).toString();

            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                "email": await getuserdata("email"),
                "pass": oldpasswordhash
            };
            const orderBy = "id DESC";
            const search = null;
            const pagination = null;
            const margedata = null;

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog("response check paswors", response);
            if (response.success && response.data.length > 0) {
                const data = {
                    "pass": newpasswordhash
                };
                const condition = {
                    "email": await getuserdata("email")
                };
                const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
                
                if (updateData.success) {
                    toast.success("Password updated successfully");
                    // Clear password fields
                    setOldpassword("");
                    setNewpassword("");
                    setConfirmpassword("");
                } else {
                    toast.error("Failed to update password. Please try again.");
                }
            } else {
                toast.error("Current password is incorrect");
            }
        } catch (error) {
            toast.error("An error occurred while updating password");
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        debugLog('Email', email);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": oldemail
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check email', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "email": email
            };
            const condition = {
                id : await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success === true) {
                toast.success("Email updated successfully");
            } else {
                toast.error("Failed to update email. Please try again.");
            }
            debugLog('updateData check email', updateData);
        } else {
            toast.error("Email not found");
        }
    };

    const handleDeleteAccount = async (e) => {
        e.preventDefault();
        const passwordhash = CryptoJS.SHA256(formData.password).toString();
        debugLog('formData', formData);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": await getuserdata("email"),
            "pass": passwordhash   
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check delete account', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "status": "2" // 2 is for deleted account
            };
            const condition = {
                "email": await getuserdata("email"),
                "pass": passwordhash
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            debugLog('updateData check delete account', updateData);
            if (updateData.success) {
                const tableSchema = "";
                const tableName = "user_delete_requests";
                const data = {
                    "reason": formData.reason,
                    "description": formData.description,
                    "status": "2",
                    "user_id": await getuserdata("id"),
                    "email": await getuserdata("email"),
                    "deleted_at": new Date().toISOString(),
                    "phone": await getuserdata("phone")
                };
                const condition = {
                    "user_id": await getuserdata("id")
                };
                const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
                debugLog('updateData check delete account', updateData);
                if (updateData.success) {
                    toast.success("Account deleted successfully");
                    localStorage.removeItem("userData");
                    navigate("/");
                } else {
                    toast.error("Failed to delete account. Please try again.");
                }
            } else {
                toast.error("Failed to delete account. Please try again.");
            }
        } else {
            toast.error("Invalid password");
        }
    };

    const handleInvoiceSettings = async (e) => {
        try {
            e.preventDefault();
            const tableSchema = "";
            const tableName = "users_billing_details";
            
            const data = {
                "user_id": await getuserdata("id"),
                "name": localInvoice.name,
                "address": localInvoice.address,
                "state": localInvoice.state,
                "city": localInvoice.city,
                "pincode": localInvoice.pincode,
                "country": localInvoice.country,
                "phone": localInvoice.phone,
                "email": localInvoice.email,
                "website": localInvoice.website,
                "gst_number": localInvoice.gst_number
            };
            let response;
            if(localInvoice.id) {
                const conditions = {
                    "user_id": await getuserdata("id")
                };
                response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            } else {
                const conditions = {
                    "id": localInvoice.id,
                    "user_id": await getuserdata("id")
                };
                response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            }
            debugLog('response check invoice settings', response);
            if (response.success) {
                toast.success("Invoice settings updated successfully");
            } else {
                toast.error("Failed to update invoice settings. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while updating invoice settings");
        }
    };



    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <form className="dc-haslayout dc-user-account">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder">
                                    <div className="dc-dashboardtabs">
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Security & Settings" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Security & Settings");
                                                }}>
                                                    Security &amp; Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Password" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Password");
                                                }}>
                                                    Password
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Email Notification" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Email Notification");
                                                }}>
                                                    Email Notification
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Social Account Details" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Social Account Details");
                                                }}>
                                                    Social Account Details
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Seo Settings" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Seo Settings");
                                                }}>
                                                    Seo Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Bank Account Details" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Bank Account Details");
                                                }}>
                                                    Bank Account Details
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Invoice Settings" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Invoice Settings");
                                                    }}>
                                                    Invoice Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Delete Account" ? 'active' : ''} `} href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleTabClick("Delete Account");
                                                }}>
                                                    Delete Account
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Security & Settings" && (
                                      <SecuritySettings/>  
                                    )}
                                    {tabsest == "Password" && (
                                      <Password oldpassword={oldpassword} setOldpassword={setOldpassword} newpassword={newpassword} setNewpassword={setNewpassword} confirmpassword={confirmpassword} setConfirmpassword={setConfirmpassword}/>  
                                    )}
                                    {tabsest == "Email Notification" && (
                                      <EmailNotification email={email} onEmailChange={setEmail} emailisvalid={emailisvalid}/>  
                                    )}
                                    {tabsest == "Social Account Details" && (
                                      <SocialAccountDetails/>  
                                    )}
                                    {tabsest == "Seo Settings" && (
                                      <SeoSettings/>  
                                    )}
                                    {tabsest == "Delete Account" && (
                                      <DeleteAccount formData={formData} setFormData={setFormData}/>  
                                    )}
                                    {tabsest == "Invoice Settings" && (
                                        <InvoiceSettings localInvoice={localInvoice} setLocalInvoice={setLocalInvoice} />
                                    )}
                                    {tabsest == "Bank Account Details" && (
                                        <BankAccountDetails />
                                    )}
                                </div>

                                <div className="dc-updatall">
                                    <i className="ti-announcement"></i>
                                    <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                    <a className="dc-btn dc-update-account22" data-id="41742" data-post="181282" href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (tabsest === "Password") {
                                            handlePasswordSubmit(e);
                                        } else if (tabsest === "Email Notification") {
                                            handleEmailSubmit(e);
                                        } else if (tabsest === "Delete Account") {
                                            handleDeleteAccount(e);
                                        } else if (tabsest === "Invoice Settings") {
                                            handleInvoiceSettings(e);
                                        } else if (tabsest === "Bank Account Details") {
                                            
                                        }
                                    }}
                                    >Save &amp; Update</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default HospitalAccountSettings;
